import React, { useEffect } from 'react';
import queryString from 'query-string';
import { updateUrl } from '../deeplink';

export const useQueryParametersFromState = (selectedInsightsTab: number) => {
  useEffect(() => {
    updateUrl('tab', JSON.stringify(selectedInsightsTab));
  }, [selectedInsightsTab]);
};

export const useSetStateFromQueryParameters = (
  setSelectedInsightsTab: React.Dispatch<React.SetStateAction<number>>
) => {
  useEffect(() => {
    const parsed = queryString.parse(window.location.search, { arrayFormat: 'comma' });
    const insightsTab = parsed.tab;
    if (insightsTab) {
      setSelectedInsightsTab(Number(insightsTab));
    }
  }, [setSelectedInsightsTab]);
};
